"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-underscore-dangle */
const core_1 = require("@angular/core");
const ngx_datatable_1 = require("@siemens/ngx-datatable");
const table_component_1 = require("../table-component/table.component");
const object_1 = __importDefault(require("../shared/services/object"));
const filtering_1 = require("../shared/services/filtering");
const custom_1 = require("../shared/models/templates/custom");
const interface_service_1 = require("../../../shared/interface/interface.service");
let CustomTemplateTableComponent = class CustomTemplateTableComponent extends table_component_1.GenericTableComponent {
    constructor(customTemplateModel, interfaceService, objectService, filteringService) {
        super(filteringService, objectService, 'vehicleTable');
        this.customTemplateModel = customTemplateModel;
        this.interfaceService = interfaceService;
        this.ColumnMode = ngx_datatable_1.ColumnMode;
        this.SortType = ngx_datatable_1.SortType;
        this.dataReady = false;
        this.selectRow = (event) => {
            const templateId = String(event.selected[0]._id);
            this.interfaceService.navigateToUrl(`/settings/custom-templates/edit/${templateId}`);
        };
        this.init = () => __awaiter(this, void 0, void 0, function* () {
            const templates = yield this.customTemplateModel.getAll();
            this.tableData = templates;
            this.filteredData = templates;
            this.dataReady = true;
        });
        this.getTableData = () => __awaiter(this, void 0, void 0, function* () { });
        this.filters = {
            title: {
                traversal: 'title',
            },
        };
        this.init();
    }
};
CustomTemplateTableComponent = __decorate([
    (0, core_1.Component)({
        selector: 'custom-template-table',
        templateUrl: require('./custom-template-table.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof custom_1.CustomTemplateModel !== "undefined" && custom_1.CustomTemplateModel) === "function" ? _a : Object, typeof (_b = typeof interface_service_1.InterfaceService !== "undefined" && interface_service_1.InterfaceService) === "function" ? _b : Object, typeof (_c = typeof object_1.default !== "undefined" && object_1.default) === "function" ? _c : Object, typeof (_d = typeof filtering_1.FilteringService !== "undefined" && filtering_1.FilteringService) === "function" ? _d : Object])
], CustomTemplateTableComponent);
exports.default = CustomTemplateTableComponent;
